import React from 'react';

const SvgDistrib = (props) => (
  <svg width={24} height={24} {...props}>
    <defs>
      <path
        id="distrib_svg__a"
        d="M10.473 23.562C5.727 17.524 2.75 12.492 2.75 9.43 2.75 4.22 7.058 0 12.37 0c5.312 0 9.62 4.22 9.62 9.429 0 3.175-3.144 8.346-7.752 14.131a2.36 2.36 0 0 1-1.868.91c-.74 0-1.44-.334-1.897-.908zM4.35 9.43c0 2.372 2.693 7.194 7.386 13.167.151.19.385.302.633.302a.76.76 0 0 0 .605-.303c4.118-5.17 7.416-10.37 7.416-13.166-.005-4.333-3.592-7.846-8.02-7.851-4.428.005-8.015 3.518-8.02 7.85zm8.02 3.982c-1.798 0-3.42-1.062-4.107-2.693a4.298 4.298 0 0 1 .971-4.756 4.51 4.51 0 0 1 4.846-.934c1.661.679 2.741 2.273 2.735 4.04-.012 2.4-1.999 4.34-4.445 4.343zM9.525 9.047c-.002 1.534 1.265 2.781 2.836 2.786 1.57.005 2.846-1.234 2.854-2.767a2.755 2.755 0 0 0-.828-1.973 2.883 2.883 0 0 0-2.017-.823c-1.57 0-2.842 1.244-2.845 2.777z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="distrib_svg__b" fill="#fff">
        <use xlinkHref="#distrib_svg__a" />
      </mask>
      <use fill="currentColor" fillRule="nonzero" xlinkHref="#distrib_svg__a" />
      <g fill="currentColor" mask="url(#distrib_svg__b)">
        <path d="M0-2.75h24v30H0z" />
      </g>
    </g>
  </svg>
);

export default SvgDistrib;
